"use client";

import { usePathname, useRouter } from "next/navigation";
import LandingPage from "./(pages)/(prelogin)/landing/page";
import Footer2 from "./component/FooterComponent/footer2";
import { useClientConfigProvider } from "./config/client-config-provider";
import AppRoutes from "./constants/routes";
import Footer from "./component/FooterComponent";

export default function Home() {
  const pathName = usePathname();
  const { config } = useClientConfigProvider();

  const router = useRouter();
  const pathname = usePathname();

  if (process.env.NEXT_PUBLIC_PROJECT_CODE === `ICICI_V1`) {
    router.push(AppRoutes.login);
  } else if (process.env.NEXT_PUBLIC_PROJECT_CODE === `HSBC_BEACH_CLUB`) {
    router.push(AppRoutes.login);
  } else if (process.env.NEXT_PUBLIC_PROJECT_CODE === `MASTERCARD_FAB`) {
    router.push(AppRoutes.login);
  }

  return (
    <>
      {![`ICICI_V1`, `HSBC_BEACH_CLUB`, `MASTERCARD_FAB`]?.includes(
        process.env.NEXT_PUBLIC_PROJECT_CODE ?? ""
      ) && (
        <div
          className={pathName == "/landing" ? "pageWrapper" : ""}
          style={{
            position: "absolute",
            bottom: 0,
            top: 0,
            left: 0,
            right: 0,
            display: "flex",
            flexDirection: "column",
          }}
        >
          <div
            className="pageHeader"
            style={{
              position: "fixed",
              width: "100%",
              zIndex: 10,
            }}
          ></div>

          <div className="indexPageInnerContainer">
            <LandingPage />
          </div>

          {config != null && config?.preLoginFooterHidden != true && (
            <div>
              <div>
                {config?.footer?.isShowCustomFooter ? <Footer2 /> : <Footer />}
              </div>
            </div>
          )}
        </div>
      )}
    </>
  );
}
